export const mixins = {
	data() {
		return {};
	},
	computed: {
		isAdminRole() {
			let { mppRoleList } = this.$store.state.userInfo;
			return mppRoleList.some((item) => item.roleName === "超级管理");
		},
		isZxkRole() {
			let { mppRoleList } = this.$store.state.userInfo;
			return mppRoleList.some((item) => item.roleName === "张兴科");
		},
		computeProductType() {
			if (this?.productType === undefined) {
				return;
			}
			if (this.isAdminRole || this.isZxkRole) {
				return this.productType;
			} else {
				return this.productType.filter((item) => {
					return item.key < 4 || item.key > 10;
				});
			}
		},
	},
};
